export default class BoardConst
{
    public static readonly WS_BOARD_TYPE_PROGRESS = 1;
    public static readonly WS_BOARD_TYPE_CUSTOM = 2;
    public static readonly BOARD_TYPE_PRIVATE = 0;
    public static readonly BOARD_TYPE_SHARED = 1;
    public static readonly BOARD_TYPE_ORG = 2;
    public static readonly BOARD_VIEW_ACTIVITY: string = '1';
    public static readonly BOARD_VIEW_SHARED: string = '2';
    public static readonly BOARD_DATATYPE_ACTIONS = 1;
    public static readonly BOARD_DATATYPE_WORKSTREAMS = 2;
    public static readonly BOARD_DATATYPE_PEOPLE = 3;
    public static readonly BOARD_DATATYPE_FREETEXT = 4;
    public static readonly OBJECT_TYPE_BOARD: string = 'board';
    public static readonly WS_HEALTH_OPTIONS = [
        {id: "", title: "None"}, 
        {id: 2, title: "OK"}, 
        {id: 1, title: "GOOD"},
        {id: 3, title: "RISK"}
    ];
    public static readonly WS_PACE_OPTIONS = [
        {id: "", title: "None"}, 
        {id: 3, title: "FAST"},
        {id: 2, title: "STEADY"}, 
        {id: 1, title: "SLOW"}
    ];
    public static readonly WS_STATUS_OPTIONS = [
        {id: "", title: "None"}, 
        {id: 1, title: "ACTIVE"}, 
        {id: 0, title: "ARCHIVE"}
    ];
    public static readonly WS_PRIORITY_OPTIONS = [
        {id: "", title: "None"},
        {id: 1, title: "P1"},
        {id: 2, title: "P2"},
        {id: 3, title: "P3"},
        {id: 4, title: "P4"},
        {id: 5, title: "P5"}
    ];
}